import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconAlertBig = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 64} height={props.height || 64} viewBox="0 0 64 64" fill="none">
      <g id="Frame">
        <path
          id="Vector"
          d="M57.9465 48L36.6131 10.6667C36.148 9.84589 35.4734 9.16318 34.6583 8.68819C33.8431 8.21321 32.9166 7.96295 31.9731 7.96295C31.0297 7.96295 30.1032 8.21321 29.288 8.68819C28.4729 9.16318 27.7983 9.84589 27.3331 10.6667L5.99981 48C5.52963 48.8143 5.28309 49.7384 5.28517 50.6787C5.28725 51.619 5.53789 52.542 6.01167 53.3542C6.48545 54.1664 7.16554 54.8389 7.983 55.3036C8.80046 55.7682 9.72623 56.0085 10.6665 56H53.3331C54.2689 55.999 55.1879 55.7519 55.9979 55.2834C56.8079 54.8149 57.4804 54.1416 57.9478 53.331C58.4153 52.5204 58.6613 51.601 58.661 50.6653C58.6608 49.7296 58.4143 48.8104 57.9465 48Z"
          stroke={props.stroke || theme.colors.text.primary}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M32 24V34.6667"
          stroke={props.stroke || theme.colors.text.primary}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M32 45.3333H32.0267"
          stroke={props.stroke || theme.colors.text.primary}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </IconBase>
  )
}
